import { makeSx } from '../../../theme/_utils'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeSx({
    networkCalloutTextBase: {
        flex: 3,
        fontWeight: 600,
        fontSize: '1rem',
        lineHeight: '1.5rem',
    },
    networkCalloutButtonBase: {
        flex: 2,
        display: 'flex',
        height: 'fit-content',
        padding: '0.75rem 1rem',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '0.5rem',
        alignSelf: 'stretch',
        color: defaultPalette.white.main,
        transition: 'opacity 0.2s ease-out',
        '& .MuiButton-icon': {
            margin: 0,
        },
    },
})
